import type { IAddress } from './types';

/**
 * Returns an object that matches the `IAddress` interface, even if
 * not all required properties are specified.
 *
 * FIXME: This matches the behavior of the Address model constructor the
 * `IAddress` interface is replacing. There may be merit in splitting the
 * interface into two for more type safety - one that requires full_name, and
 * one that makes it optional.
 *
 */
export function createAddressFromPartialValues(partialValues?: Partial<IAddress>): IAddress {
  return {
    full_name: '',
    line1: '',
    line2: '',
    city: '',
    state: '',
    postal_code: '',
    // SUPPORT-19535 Non-empty country value required.
    country: 'US',
    ...partialValues,
  };
}
